import * as React from "react";
import styles from "./icons.module.scss";

export default function CheckboxIcon({ width = "100%", height, stroke, background = true, style } = {}) {
    return (
        <svg width={width} height={height} style={style} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            {background && <circle className={styles["brand-background-fill"]} cx="8" cy="8" r="7" fill="#20232B" stroke={stroke && "white"} />}
            <rect className={styles["brand-color-fill"]} x="3.77051" y="7.98047" width="1.40743" height="4.22228" rx="0.703713" transform="rotate(-45 3.77051 7.98047)" />
            <rect className={styles["brand-color-fill"]} x="11.2334" y="4.49854" width="1.40743" height="7.74084" rx="0.703713" transform="rotate(45 11.2334 4.49854)" />
        </svg>
    );
}
